/** Mirrors server/order-issue-config.js for the report-issue UI. */

export const ISSUE_REPORT_WINDOW_HOURS = 48;

export function isWithinIssueReportWindow(createdAt: string): boolean {
  const created = new Date(createdAt).getTime();
  if (Number.isNaN(created)) return false;
  return Date.now() - created <= ISSUE_REPORT_WINDOW_HOURS * 60 * 60 * 1000;
}

export const ORDER_ISSUE_TYPES = [
  { id: 'missing_items', label: 'Missing item(s)', needsItems: true },
  { id: 'wrong_items', label: 'Wrong item or wrong order', needsItems: true },
  { id: 'quality', label: 'Quality problem', needsItems: true },
  { id: 'not_ready', label: 'Order not ready / could not collect', needsItems: false },
  { id: 'payment', label: 'Payment problem', needsItems: false },
  { id: 'points', label: 'Points or rewards issue', needsItems: false },
  { id: 'other', label: 'Other', needsItems: false },
] as const;

export const RESOLUTION_OPTIONS = [
  { id: 'refund_card', label: 'Refund to my card' },
  { id: 'refund_points', label: 'Refund as Qahwahub credit' },
] as const;

export type OrderIssueTypeId = (typeof ORDER_ISSUE_TYPES)[number]['id'];

export const ISSUE_STATUS_LABELS: Record<string, string> = {
  submitted: 'Submitted — waiting for review',
  under_review: 'Under review',
  approved: 'Approved',
  declined: 'Declined',
  needs_info: 'More info needed',
};

export const REFUND_OUTCOME_LABELS: Record<string, string> = {
  pending: 'Refund not decided yet',
  none: 'No refund',
  partial: 'Partial refund',
  full: 'Full refund',
};

export function getRefundOutcomeLabel(id: string): string {
  return REFUND_OUTCOME_LABELS[id] || id.replace(/_/g, ' ');
}

export function getIssueTypeLabel(id: string): string {
  return ORDER_ISSUE_TYPES.find((t) => t.id === id)?.label || id.replace(/_/g, ' ');
}

export function getResolutionLabel(id: string): string {
  return RESOLUTION_OPTIONS.find((o) => o.id === id)?.label || id.replace(/_/g, ' ');
}
